import Indicator, { IndicatorType } from '../types/Indicator'

const Open: Indicator = {
  type: IndicatorType.PRICE,
  value: 'open',
  label: 'Open',
  fields: ['open'],
}

export default Open
